import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '@/pages/Home'
import ItemType from '@/pages/ItemType'
import ItemDetail from '@/pages/ItemDetail'
import Custom from '@/pages/Custom'
import Preview from '@/pages/Preview'
import MyCustom from '@/pages/MyCustom'
import Faq from '@/pages/Faq'
import Howto from '@/pages/Howto'
import Marker from '@/pages/Marker'

import MirrorHome from '@/pages/mirror/MirrorHome'
import MirrorItemType from '@/pages/mirror/MirrorItemType'
import MirrorItemDetail from '@/pages/mirror/MirrorItemDetail'
import MirrorCustom from '@/pages/mirror/MirrorCustom'
import MirrorDemo from '@/pages/mirror/MirrorDemo'
import MirrorQRcode from '@/pages/mirror/MirrorQRcode'
import MirrorCustomID from '@/pages/mirror/MirrorCustomID'
import MirrorPreview from '@/pages/mirror/MirrorPreview'
import MirrorMode from '@/pages/mirror/MirrorMode'

import NotFound from '@/pages/NotFound'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      name: 'home',
      path: '/',
      component: Home
    },
    {
      path: '/index.html',
      redirect: { name: 'home' }
    },
    {
      name: 'item-type',
      path: '/type/:brandID',
      component: ItemType,
      props: route => ({
        brandID: Number(route.params.brandID)
      })
    },
    {
      name: 'item-detail',
      path: '/detail/:id',
      component: ItemDetail,
      props: route => ({
        id: String(route.params.id)
      })
    },
    {
      name: 'custom',
      path: '/custom',
      component: Custom
    },
    {
      name: 'preview',
      path: '/preview/:customID',
      component: Preview,
      props: route => ({
        customID: String(route.params.customID)
      })
    },
    {
      name: 'mycustom',
      path: '/mycustom',
      component: MyCustom
    },
    {
      name: 'faq',
      path: '/faq',
      component: Faq
    },
    {
      name: 'howto',
      path: '/howto',
      component: Howto
    },
    {
      name: 'marker',
      path: '/marker',
      component: Marker
    },
    {
      name: 'mirror-home',
      path: '/mirror',
      component: MirrorHome
    },
    {
      name: 'mirror-item-type',
      path: '/mirror/type/:brandID',
      component: MirrorItemType,
      props: route => ({
        brandID: Number(route.params.brandID)
      })
    },
    {
      name: 'mirror-item-detail',
      path: '/mirror/detail/:id',
      component: MirrorItemDetail,
      props: route => ({
        id: String(route.params.id)
      })
    },
    {
      name: 'mirror-custom',
      path: '/mirror/custom',
      component: MirrorCustom
    },
    {
      name: 'mirror-demo',
      path: '/mirror/demo/:customID',
      component: MirrorDemo,
      props: route => ({
        customID: String(route.params.customID)
      })
    },
    {
      name: 'mirror-qrcode',
      path: '/mirror/qrcode',
      component: MirrorQRcode
    },
    {
      name: 'mirror-customid',
      path: '/mirror/customid',
      component: MirrorCustomID
    },
    {
      name: 'mirror-preview',
      path: '/mirror/preview/:customID',
      component: MirrorPreview,
      props: route => ({
        customID: String(route.params.customID)
      })
    },
    {
      name: 'mirror-mode',
      path: '/mirror/mode',
      component: MirrorMode
    },
    {
      name: 'not-found',
      path: '/404',
      component: NotFound
    },
    {
      path: '*',
      redirect: { name: 'not-found' }
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router.js